import { useTranslation } from "react-i18next";

import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { useCloseFile } from "src/core/hooks/folder/useCloseFile";

export const CloseFileModal: React.FC<{
  open: boolean;
  setOpen: (open: boolean) => void;
}> = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const { handleClose, isLoading } = useCloseFile(setOpen);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent hideCloseButton>
        <DialogHeader>
          <DialogTitle>{t("folder.close.title")}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="whitespace-pre-wrap">
          {t("folder.close.description")}
        </DialogDescription>
        <DialogFooter className="gap-x-10">
          <Button onClick={handleClose} loading={isLoading}>
            {t("folder.close.confirm")}
          </Button>
          <Button variant="link" onClick={() => setOpen(false)} disabled={isLoading}>
            {t("global.form.cancel")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
